import { CommonModule, JsonPipe } from '@angular/common';
import { Component, inject, model } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-dialog-generic',
  imports: [MatDialogModule, FormsModule, CommonModule, MatFormFieldModule, MatButtonModule,
    JsonPipe, FormsModule, ReactiveFormsModule, CommonModule, MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogContent,
    MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    MatOptionModule,
    MatSelectModule
  ],
  templateUrl: './dialog-generic.component.html',
  styleUrl: './dialog-generic.component.css'
})
export class DialogGenericComponent {
  readonly dialogRef = inject(MatDialogRef<DialogGenericComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly animal = model(this.data.animal);

  selectedElementType: string = 'input';
  labelText: string = '';
  insertIndex: number | null = null;

  onNoClick(): void {
    this.dialogRef.close();
  }

  crea(){
    console.log("Funzione ciao");
    const myObject = {
      selectedElementType: this.selectedElementType,
      labelText: this.labelText,
      insertIndex: this.insertIndex
    };

    this.dialogRef.close(myObject);
  }
}
